<section>
  <div #sideSection class="background-background">
    <div class="nav-item" *ngFor="let item of settingsNavItems">
      <a [routerLink]="'/settings' + item.href" (click)="linkClick()" class="nav-link lead secondary top-link" routerLinkActive="active">{{item.name}}</a>
      <ul class="nav nav-pills flex-column" *ngIf="item?.subNav?.length > 0">
        <li class="list-unstyled tr-icon-list" *ngFor="let subItem of item.subNav">
          <a [routerLink]="'/settings' + subItem.href" (click)="linkClick()" class="nav-link secondary side-text" [class.disabled]="subItem.disabled" routerLinkActive="active">
            <tr-icon [icon]="subItem.icon" [disabled]="subItem.disabled" class="mr-1"></tr-icon>
            <span class="text-capitalize" [ngbTooltip]="subItem.tooltip">{{subItem.name}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</section>
